<template>
  <div class="footer wrap">
    <div class="bar">
      <span>网站主办方：广东省政府采购协会</span>
      <span>版权所有：广东省政府采购协会</span>
      <span class="cBlack">粤ICP备15021007号</span>
    </div>
    <div class="bar">
      <span>网站维护邮箱：<em>gdscgxh@163.com</em></span>
      <span class="cBlack contact" @click="contact">联系我们</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  mounted() {},
  methods: {
    contact() {
      let routeData = this.$router.resolve({
        name: 'List',
        params: { type: 7 },
        query: {
          sType: 75
        }
      });
      window.open(routeData.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.footer {
  background: #fff;
  border-top: 5px solid #013f99;
  padding: 19px 0 60px;
  &.wrap {
    width: 1198px;
  }
  .bar {
    padding: 9px 0;
    text-align: center;
  }
  span {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    line-height: 20px;
    color: #666;
    margin: 0 10px;
    em {
      color: #333;
    }
  }
  .cBlack {
    color: #333;
  }
  .contact {
    cursor: pointer;
  }
}
</style>
